/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".primary-background[_ngcontent-%COMP%]{background-color:var(--primary-color)}.secondary-background[_ngcontent-%COMP%]{background-color:var(--secondary-color)}.scroll-to-top[_ngcontent-%COMP%]{position:fixed;bottom:130px;right:22px;z-index:1001;display:none;transition:all .2s ease-in-out}.show-scroll-to-top[_ngcontent-%COMP%]{opacity:1;display:block;transition:all .2s ease-in-out}"];
export { styles as styles };
